import 'slick-carousel';

const addSlides = ($slider) => {
	if ($slider.find('.slider__slide').length % 4 === 0) {
		return
	} else {
		$slider.append('<div class="slider__slide slider__slide--empty"></div>');
		addSlides($slider);
		return;
	}
};

const handleGallerySliders = () => {
	const $sliderImages = $('.js-slider-images .slider__slides');
	const $sliderThumbs = $('.js-slider-thumbs .slider__slides');

	const $imageSlide = $sliderImages.find('.slider__slide');
	const $thumSlide = $sliderThumbs.find('.slider__slide');

	addSlides($sliderThumbs);

	$sliderImages.slick({
		infinite: true,
	  	slidesToShow: 1,
	  	slidesToScroll: 1,
	  	arrows: false,
	  	dots: false,
	  	fade: true,
	  	accesibility: false,
        draggable: false,
        swipe: false,
        touchMove: false
	 	// asNavFor: '.js-slider-thumbs .slider__slides'
	});

	$sliderThumbs.slick({
		infinite: true,
		slidesToShow: 4,
	  	slidesToScroll: 4,
	  	// asNavFor: '.js-slider-images .slider__slides',
	  	dots: false,
	  	arrows: true,
	  	prevArrow: $('.js-slider-thumbs .js-slider-arrow-prev'),
		nextArrow: $('.js-slider-thumbs .js-slider-arrow-next'),
		draggable: false,
		swipe: false,
		// focusOnSelect: true
	});

	$sliderImages.on('init', function(event, slick, currentSlide) {
		const $activeSlide = $sliderImages.find('.slick-current');
		const $target = $activeSlide.find('.slider__slide');

		playPauseVideo($target, 'play');
	});

	$sliderImages.on('beforeChange', function(event, slick, currentSlide) {
		const $activeSlide = $sliderImages.find('.slick-current');
		const $target = $activeSlide.find('.slider__slide');
		const $iframe = $activeSlide.find('iframe');

		playPauseVideo($target, 'pause');
	});

	$sliderImages.on('afterChange', function(event, slick, currentSlide) {
		const $activeSlide = $sliderImages.find('.slick-current');
		const $target = $activeSlide.find('.slider__slide');
		const $iframe = $activeSlide.find('iframe');

		playPauseVideo($target, 'play');
	});

	$thumSlide.eq(0).closest('.slick-slide').addClass('is-active')

	$thumSlide.each(function(thumbIndex, el) {
		const $thumb = $(this);

		$thumb.on('click', function(event) {
			event.preventDefault();

			$thumb.closest('.slick-slide').addClass('is-active').siblings().removeClass('is-active');

			$imageSlide.each(function(imageIndex, el) {
				const $image = $(this);

				if (thumbIndex === imageIndex) {
					$sliderImages.slick('slickGoTo', thumbIndex, true);
				}
			});
		});
	});
};

handleGallerySliders();

function playPauseVideo($activeSlide, control) {
	let slideType;
  	let player;
  	let video;

  	slideType = $activeSlide.attr('class').split(' ')[1];
  	player = $activeSlide.find('iframe').get(0);

  	if (slideType === 'youtube') {
    	switch (control) {
      		case 'play':
	        	postMessageToPlayer(player, {
	          		event: 'command',
			        func: 'unMute'
	        	});
		        postMessageToPlayer(player, {
	          		event: 'command',
	          		func: 'playVideo'
	        	});
        	break;
      		case 'pause':
		        postMessageToPlayer(player, {
		          	event: 'command',
		          	func: 'pauseVideo'
		        });
		        postMessageToPlayer(player, {
	          		event: 'command',
			        func: 'unMute'
	        	});
        	break;
    	};
  	}
};

function postMessageToPlayer(player, command) {
	if (player == null || player == undefined || command == null) return;
  	player.contentWindow.postMessage(JSON.stringify(command), "*");
};
